import { render, staticRenderFns } from "./articleFilters.vue?vue&type=template&id=4e15aa6a"
import script from "./articleFilters.vue?vue&type=script&lang=js"
export * from "./articleFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports